import { OChainId, TChainId } from 'modules/api';
import { Address, TBitcoinNetwork } from 'modules/common/types';

export type TNetwork = TChainId | TBitcoinNetwork;

export type TLinkType = 'tx' | 'address' | 'block';

const explorerLinks: Partial<Record<TNetwork, string>> = {
  [OChainId.ethereum]: 'https://etherscan.io',

  bitcoin: 'https://lombard.mempool.space',
  bitcoinSignet: 'https://mempool.space/signet',

  [OChainId.sonic]: 'https://sonicscan.org',
};

/**
 * Returns the link to the explorer for the given network.
 *
 * @param addr - The address or tx hash.
 * @param network - The network.
 * @param type - The type of link. Default is `tx`.
 *
 * @returns The link to the explorer.
 */
export function getExplorerLink(
  addr: Address,
  network: string | number,
  type: TLinkType = 'tx',
): string | undefined {
  const url = explorerLinks[network as TNetwork];

  if (!url) {
    return undefined;
  }

  return `${url}/${type}/${addr}`;
}
